import { Plus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { RelationRef } from '../timeline/types'
import { AgreementCard } from './AgreementCard'
import type { Agreement, RelationAgreements } from './types'

/** "Afspraken (n)" on Overzicht (design §4.4/§4.5): the active agreements, own first, then via. */
export function AgreementsSection({
  relation,
  data,
  failed,
  onNew,
  onEdit,
  onContact,
  onChanged,
}: {
  relation: RelationRef
  data: RelationAgreements | null
  failed: boolean
  onNew: () => void
  onEdit: (agreement: Agreement) => void
  onContact: (agreement: Agreement) => void
  onChanged: () => void
}) {
  const active = (data ? [...data.own, ...data.via] : []).filter((agreement) => agreement.status === 'actief')
  const viaIds = new Set(data?.via.map((agreement) => agreement.id))
  return (
    <section aria-labelledby={`afspraken-${relation.id}`} className="vonk-card flex flex-col gap-2 p-5">
      <div className="flex items-center justify-between">
        <h2 id={`afspraken-${relation.id}`} className="font-heading text-base font-semibold">
          Afspraken ({active.length})
        </h2>
        <Button type="button" size="sm" variant="outline" onClick={onNew}>
          <Plus />
          Afspraak
        </Button>
      </div>
      {failed ? <p className="text-sm text-destructive">Afspraken laden mislukt.</p> : null}
      {data && active.length === 0 ? <p className="text-sm text-muted-foreground">Nog geen lopende afspraken.</p> : null}
      {active.map((agreement) => (
        <AgreementCard
          key={agreement.id}
          agreement={agreement}
          readOnly={relation.kind === 'organisation' && viaIds.has(agreement.id)}
          showParty={viaIds.has(agreement.id)}
          onEdit={onEdit}
          onContact={onContact}
          onChanged={onChanged}
        />
      ))}
    </section>
  )
}
